<template>
  <div>
    <div class="control_box">
      <div>
        <el-date-picker
          v-model="dateTime"
          type="daterange"
          size="small"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <div class="control_btn">
        <span>
          <el-button type="primary" size="small" icon="el-icon-search" @click="SearchByTimeClick">
            查询
          </el-button>
        </span>
        <span>
          <el-button type="primary" plain size="small" icon="el-icon-refresh" @click="reset">
            重置
          </el-button>
        </span>
        <span>
          <el-button
            type="primary"
            plain
            size="small"
            icon="el-icon-folder-opened"
            @click="Addexport"
          >
            导出明细
          </el-button>
        </span>
      </div>
    </div>
    <div class="table">
      <el-table
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        :header-cell-style="{
          fontSize: '13px',
          color: '#787878',
          background: '#F5F5F5',
          textAlign: 'center'
        }"
        :cell-style="{ fontSize: '14px', color: '#140000', textAlign: 'center' }"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column v-if="tabType==='moneyTable'" prop="operateType" label="操作类型"></el-table-column>
        <el-table-column v-else prop="fromDesc" label="操作类型"></el-table-column>
        <el-table-column v-if="tabType==='moneyTable'" prop="sourceOrderCode" label="来源单号"></el-table-column>
        <el-table-column v-else prop="fromCode" label="来源单号"></el-table-column>
        <el-table-column
          v-if="useType ==='Y'"
          prop="useTypeName"
          label="用途"
        ></el-table-column>
        <el-table-column v-if="tabType==='goodsDetail'" prop="goodsProductCode" label="产品编码"> </el-table-column>
        <el-table-column v-if="tabType==='goodsDetail'" prop="goodsProductName" label="产品名称"> </el-table-column>
        <el-table-column  v-if="type === 'up'" :prop="moneyType" label="上账金额（元）"></el-table-column>
        <el-table-column v-else :prop="moneyType" label="金额（元）"></el-table-column>
        <el-table-column :prop="optionDate" label="操作日期"></el-table-column>
      </el-table>
    </div>
    <div v-if="dialogVisible">
      <Addexports
        :dateTimes="dateTime"
        :visible.sync="dialogVisible"
        :functionCode="functionCode"
        :parentCode="parentCode"
        :requestUrl="requestUrl"
        @updateVisible="updateVisible"
        @resetPopupData="resetPopupData"
        @submitPopupData="submitPopupData"
        @handleClose="handleClose"
      />
    </div>
    <div class="pageschange">
      <el-pagination
        background
        layout="total,prev, pager, next"
        prev-text="上一页"
        next-text="下一页"
        :total="total"
        :page-size="page.pageSize"
        :current-page="page.pageNum"
        :hide-on-single-page="hiddenPage"
        @current-change="currentPageChange"
        @size-change="currentSizeChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
/**
 *   @Author : 李阳
 *   @Date : 2021/4/1
 *   @Version : 1.0.0
 *   @Last Modified by : 李阳
 *   @Last Modified time : 2021/4/1
 *   @desc 费用池公共table展示/查询组件封装
 **/
import Addexports from './AddexportFile'
export default {
  name: 'DetailTable',
  props: {
    tableData: Array,
    type: String,
    page: Object,
    total: Number,
    hiddenPage: Boolean,
    functionCode: String,
    parentCode: String,
    requestUrl: String,
    loading: Boolean,
    useType:String,
    tabType:String
  },
  components: {
    Addexports
  },
  data() {
    return {
      dateTime: [],
      moneyType: 'totalAmount',
      optionDate: 'accountDateTime',
      dialogVisible: false
    }
  },
  created() {
    this.alterMoneyType()
  },
  methods: {
    Addexport() {
      this.dialogVisible = !this.dialogVisible
    },
    // 修改是否让页面显示与隐藏的事件
    updateVisible(val) {
      this.dialogVisible = val
    },
    // 点击取消的事件
    resetPopupData() {
      // 这里可重置数据
      this.dialogVisible = false
    },
    // 点击确定的按钮
    async submitPopupData() {
      this.dialogVisible = false
    },
    // 关闭弹框（头部的X）
    handleClose() {
      this.dialogVisible = false
    },
    /********************table头部按钮方法封装************************/
    /**
     * @description 费用上账/使用金额字段修改函数
     * @param { String } totalAmount     上账金额
     * @param { String } operationAmount 使用金额
     */
    alterMoneyType() {
      if (this.type == 'up') {
        this.moneyType = this.tabType==='moneyTable'?'amount':'totalAmount'
        this.optionDate = this.tabType==='moneyTable'?'operateTime':'accountDateTime'
      } else if (this.type == 'use') {
        this.moneyType =  this.tabType==='moneyTable'?'amount':'operationAmount'
        this.optionDate = this.tabType==='moneyTable'?'operateTime':'operationDateTime'
      }
    },
    /**
     * @description 时间查询按钮点击函数
     * @param { String } beginDate 开始时间
     * @param { String } endDate   结束时间
     */
    SearchByTimeClick() {
      let timeData = {
        beginDate: this.dateTime[0] || '',
        endDate: this.dateTime[1] || ''
      }
      this.$emit('dateTimeChange', this.type, timeData)
    },
    /**
     * @description 时间重置按钮点击函数
     */
    reset() {
      this.dateTime = []
      this.$emit('timeReset', this.type)
    },
    /**************************分页器方法封装*******************************/
    /**
     * @description 页码变化监听函数
     */
    currentPageChange(val) {
      this.$emit('pageChange', this.type, val)
    },
    /**
     * @description 页条数变化监听函数
     */
    currentSizeChange(val) {
      this.$emit('sizeChange', this.type, val)
    }
  }
}
</script>
<style lang="scss" scoped>
.control_box {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  .control_btn {
    display: flex;
    span:nth-child(1) {
      margin: 0 20px;
    }
    span:nth-child(3) {
      margin: 0 0 0 20px;
    }
  }
}
.table {
  margin-top: 20px;
  /deep/.el-table {
    td {
      vertical-align: top; //让表格内容不垂直居中
    }
  }
}
/deep/.el-input__inner {
  border-radius: 2px;
  background: #f5f5f5;
}
/deep/ .el-range-input {
  background: #f5f5f5;
}
/deep/.el-range-editor.el-input__inner {
  width: 236px;
}
.pageschange {
  margin: 20px 0px;
  text-align: center;
}
</style>
